declare const __BUILD_TIMESTAMP__: string;

export const BUILD_ID = typeof __BUILD_TIMESTAMP__ !== 'undefined' ? __BUILD_TIMESTAMP__ : 'dev';

export function logBuildVersion(): void {
  console.log(
    `%c[Chawni] Build: ${BUILD_ID} | ${new Date(Number(BUILD_ID) || Date.now()).toISOString()}`,
    'color: #0D47A1; font-weight: bold; font-size: 11px;'
  );
}
